import { render, staticRenderFns } from "./item-meta.vue?vue&type=template&id=02b24c5f"
import script from "./item-meta.vue?vue&type=script&lang=js"
export * from "./item-meta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports